// IE 10

/**
 * Element.closest Polyfill
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
 */
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;
        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

(function(){
    var links = document.querySelectorAll('.site-reveal__link, .site-reveal__open-link');
    if (!links.length) return;
    links.forEach(function(openAction){
        var openLink = openAction.querySelector('a, button');
        var contentId = (openLink.getAttribute('href') || openLink.getAttribute('data-target')).replace('#', '');
        var content = document.getElementById(contentId);
        // hide content if not already hidden
        content.className += ' hidden';
        // detect close-link
        var closeAction = openAction.nextElementSibling, closeLink;
        if( closeAction && closeAction.classList.contains('site-reveal__close-link')) {
            closeAction = openAction.nextElementSibling;
            closeAction.classList.add('off');
            closeLink = closeAction.querySelector('a, button');
            closeLink.addEventListener('click', function(e){
                e.preventDefault();;
                closeAction.classList.remove('on');
                closeAction.classList.add('off');
                openAction.classList.remove('off');
                openAction.classList.add('on');
                openLink.focus();
                content.classList.add('hidden');
            }, false);
        }

        openAction.classList.add('on');
        openLink.addEventListener('click', function(e){
            e.preventDefault();
            // clear focus so that page does not jump down with the currently focused element
            document.activeElement.blur();
            content.classList.remove('hidden');
            if (closeAction) {
                closeAction.classList.remove('off');
                closeAction.classList.add('on');
                openAction.classList.remove('on');
                openAction.classList.add('off');
            }
        }, false);

    });
})();
